var _defs, _rect, _rect2, _rect3, _g, _path, _path2, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F96E2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "waterGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D6A98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#F96E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D6A98D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "waterGradientRadial",
    cx: "75.5%",
    cy: "0%",
    r: "50%",
    fx: "75.5%",
    fy: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F96E2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#F96E2A",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D6A98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sunMask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 200,
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    fill: "url(#skyGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 200,
    width: 800,
    height: 200,
    fill: "url(#waterGradient)",
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 200,
    width: 800,
    height: 200,
    fill: "url(#waterGradientRadial)",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sunMask)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 200,
    r: 50,
    fill: "#F96E2A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 200,
    r: 60,
    fill: "none",
    stroke: "#F96E2A",
    strokeOpacity: 0.2,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 200,
    r: 80,
    fill: "none",
    stroke: "#F96E2A",
    strokeOpacity: 0.1,
    strokeWidth: 20
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,180             Q80,130 160,150             Q240,170 320,145             Q400,120 480,160             Q520,185 550,195             Q560,198 570,200             L570,200 L0,200 Z",
    fill: "#0A2F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M630,200             Q640,198 660,192             T740,170 T800,160             L800,200 L630,200 Z",
    fill: "#0A2F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,195         Q50,165 100,175         Q140,185 180,170         Q220,155 260,175         Q300,190 330,195         Q340,197 350,200         L350,200 L0,200 Z",
    fill: "#2B5765"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,-1) translate(0,-400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,180             Q80,130 160,150             Q240,170 320,145             Q400,120 480,160             Q520,185 550,195             Q560,198 570,200             L570,200 L0,200 Z",
    fill: "#0A2F3F",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,200               Q640,198 660,192               T740,170 T800,160               L800,200 L630,200 Z",
    fill: "#0A2F3F",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,195         Q50,165 100,175         Q140,185 180,170         Q220,155 260,175         Q300,190 330,195         Q340,197 350,200         L350,200 L0,200 Z",
    fill: "#2B5765",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.a4a44e43c474fbd648104cb19302bd40.svg";
export { ForwardRef as ReactComponent };